import React from "react";

const PaymentsIndex = () => {
  return <React.Fragment>Payments TODO</React.Fragment>;
};

export default PaymentsIndex;
